<template>
  <v-container>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="tables"
      :items-per-page="10"
      class="elevation-1"
    ></v-data-table>
  </v-container>
</template>

<script>
export default {
  props: ["isLoad"],
  data: () => ({
    tables: [],
    headers: [
      {
        text: "Code",
        value: "job_Code"
      },
      {
        text: "Name",
        value: "job_Name"
      }
    ],
    isLoading: false
  }),
  created() {},
  methods: {
    getLocation() {
      this.isLoading = true;
      this.$axios
        .get(`/api/TheFourth/jobTitles`)
        .then(({ data }) => {
          this.tables = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  watch: {
    isLoad(val) {
      if (val) {
        this.getLocation();
      }
    }
  }
};
</script>
